import {
  Dialog,
  DialogContent,
  Button,
  Stack,
  Typography,
  Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

type Props = {
  open: boolean;
  onClose: () => void;
  onRetry: () => void;
};

const FailureModal: React.FC<Props> = ({ open, onClose, onRetry }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      sx={{
        "& .MuiDialog-paper": {
          maxWidth: "550px",
        },
      }}
    >
      <DialogContent>
        <Stack alignItems="center" spacing={2} py={3}>
          {/* Red circle with white X */}
          <Box
            sx={{
              width: 80,
              height: 80,
              borderRadius: "50%",
              backgroundColor: "error.main",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <CloseIcon sx={{ color: "white", fontSize: 50 }} />
          </Box>

          <Typography variant="h6" align="center" fontWeight={700}>
            Failed to Generate Report
          </Typography>
          <Typography variant="body2" color="text.secondary" align="center">
            An error occurred during the data upload or report generation
            process. Please ensure your data format is correct and your internet
            connection is stable
          </Typography>
        </Stack>

        {/* Single retry button */}
        <Stack direction="row" justifyContent="center" mt={2}>
          <Button
            variant="contained"
            onClick={onRetry}
            sx={{ textTransform: "none", color: "secondary.contrastText" }}
            fullWidth
          >
            Try Again
          </Button>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default FailureModal;
